import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';


@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {

  public footerText: string;
  public url: string = 'http://www.vbt.com.tr/';
  public year: number;

  constructor(private _title: Title) {

  }
  ngOnInit() {
    this.year = new Date().getFullYear();
    this.footerText = this._title.getTitle();

    if (environment.Key === 'SANKOTEST' || environment.Key === 'SANKOPROD') {
      this.url = 'https://www.sankonline.com/';
    }

  }

}